import script from "./Payment.vue?vue&type=script&setup=true&lang=ts"
export * from "./Payment.vue?vue&type=script&setup=true&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=7a9bf6fc&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9bf6fc"]])

export default __exports__